import { useTranslation } from "react-i18next";
import { Suspense, useRef, useState } from "react";
import { Toast } from "primereact/toast";
import AppLoading from "../app-loading/app-loading";
import AccountsCashDatatable from "./accounts-cash-datatable";
import AccountsCashSearch from "../delivery-AccCash-collection/aacounts-cash-search";
import DeliveryCashService from "../../services/deliverycash/deliverycashservice";

const AccountsCashMain = () => {
  const { t } = useTranslation();
  const toast = useRef<Toast>(null);
  const [AccountscashData, setAccountscashData] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [lastFilterPayload, setLastFilterPayload] = useState<any>(null);
   const [showHistoryDialog, setShowHistoryDialog] = useState(false);

  const handleSearch = async (filterPayload: any) => {
    setLoading(true);
    setLastFilterPayload(filterPayload);
    try {
      const result = await DeliveryCashService.GetAccountsCashDetails(filterPayload);
      debugger // <-- Your new API call
      if (Array.isArray(result) && result.length > 0) {
        setAccountscashData(result);
      } else {
        // toast.current?.show({
        //   severity: "info",
        //   summary: "No Data",
        //   detail: "No cash collection records found.",
        // });
        setAccountscashData([]);
      }
    } catch (error) {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: "Failed to fetch data.",
      });
      setAccountscashData([]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Suspense fallback={<AppLoading />}>
      <Toast ref={toast} position="top-right" />
      <div className="layout-content mt-3 mb-3 grid grid-table-mobile">
         <div className="col-12">
          <h5 className="ml-1 mb-0">{t("Accounts Collection")}</h5>
        </div>

        <div className="col-12">
          <AccountsCashSearch setLoading={setLoading}
           onSearch={handleSearch} 
           refreshData={() => lastFilterPayload && handleSearch(lastFilterPayload)}
           onReset={() => setAccountscashData([])}
           />
        </div>

        <div className="col-12">
          <AccountsCashDatatable
            data={AccountscashData}
            loading={loading}
            refreshData={() => lastFilterPayload && handleSearch(lastFilterPayload)}
          />
        </div>
      </div>
      {loading && <AppLoading />}
    </Suspense>
  );
};

export default AccountsCashMain;
